import BasicIcon from "components/basic-icon/BasicIcon";
import { FieldPopoverProps } from "components/forms/part/FieldPopover/types";
import log from "logger";
import { Component } from "react";

export class FieldPopover extends Component<FieldPopoverProps> {
	render():JSX.Element{

		let content = this.props.content;

		if(!this.props.hide && !this.props.content){
			content = <div>No popover content provided</div>;
		}

		const classNames = ["field-popover"];

		if(this.props.hide){
			classNames.push("hide");
		}

		return (
			<div className={classNames.join(" ")}>
				<div
					popovertarget={this.props.id}
					popovertargetaction="show"
					onMouseEnter={this.showPopover}
					onMouseLeave={this.hidePopover}
					onClick={this.togglePopover}
					style={{ anchorName: `--${this.props.id}` }}
				>
					<BasicIcon icon={this.props.icon} />
				</div>
				<div id={this.props.id} popover="auto" style={{ positionAnchor: `--${this.props.id}`}}>
					{content}
				</div>
			</div>
		);
	}

	showPopover = ():void => { // Event
		const target = document.getElementById(this.props.id);
		if(!target){
			log.warn(`Unable to find popover target ${this.props.id}`);
			return;
		}

		(target as any).showPopover(); // Reason: Used "as any" because the versions of React and TS in use at the time did not understand .showPopover
	}

	hidePopover = ():void => { // Event
		const target = document.getElementById(this.props.id);
		if(!target){
			log.warn(`Unable to find popover target ${this.props.id}`);
			return;
		}

		(target as any).hidePopover(); // Reason: Used "as any" because the versions of React and TS in use at the time did not understand .showPopover
	}

	togglePopover = ():void => { // Event
		const target = document.getElementById(this.props.id);
		if(!target){
			log.warn(`Unable to find popover target ${this.props.id}`);
			return;
		}

		(target as any).togglePopover(); // Reason: Used "as any" because the versions of React and TS in use at the time did not understand .showPopover
	}
}
